module.exports = __webpack_public_path__ + "static/media/hovered_eye.0c9e80c0.svg";